
import { Component, Vue, Prop } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { FileType } from '@/models/file-type';
import { APP_CONFIG } from '@/config/app-config';

import u from '@/utility/utility';

import DeliveryInfo from './components/DeliveryInfo.vue';
import PayServiceInfo from './components/PayServiceInfo.vue';
import { Customer } from '@/models/customer';
import { PayServiceModel } from '@/models/payservice';

import authService from '@/services/auth-services';
import commonService from '@/services/common-services';
import payserviceService from '@/services/payservice-services';
import orderService from '@/services/order-service';

@Component({
    components: {
        Loading,
        'delivery-info': DeliveryInfo,
        'payservice-info': PayServiceInfo,
    }
})
export default class AddNewPayService extends Vue {
    private customerInfo: Customer = {};
    private payService: PayServiceModel = {};
    private listImages = [] as FileType[];
    private isLoading = false;

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private async created() {
        this.getRate();
        this.getCustomersInfo();
    }

    private async getRate() {
      const result = await commonService.exchangeRate();
      if (result && result.status === 200) {
        (window['getApp'] as any).$emit('SET_RATE', result.data.data.exchange_rate);
      }
    }

    private async getCustomersInfo() {
        if (this.userInfo.userId > 0) {
            const result = await authService.customersInfo(this.userInfo.userId);
            if(result && result.status === 200) {
                (window['getApp'] as any).$emit('APP_SET_CUSTOMER_INFO', result.data.data || {});
                this.customerInfo = {
                    ...result.data.data
                };
            }
        }
    }
    private async onUploadImage() {
        for(const image of this.listImages) {
            if(image.file === undefined) {
                continue;
            }
            try {
                const formData = new FormData();
                formData.append('imagefile', image.file as any);
                formData.append('filename', image.fileName);
                
                const result = await orderService.uploadImage(formData);
                
                if (result && result.status === 200 && result.data.data) {
                    // Lưu URL đã upload vào image object
                    image.src = result.data.data;
                }
            } catch (error) {
                // Upload error, continue with next image
            }
        }
    }

    private async submitPayService() {
        if(!this.payService.content) {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Hãy nhập nội dung chuyển khoản!',
            });
            return;
        }
        this.isLoading = true;
        await this.onUploadImage();
        const dataRequest = {
            UID: this.userInfo.userId,
            Username: this.userInfo.userName,
            Status: 2,
            ExchangeRate: this.rate,
            Amount: this.payService.amount,
            BankName: this.payService.bankName,
            BankAccountNumber: this.payService.bankAccountNumber,
            BankAccountName: this.payService.bankAccountName,
            Content: this.payService.content,
            Images: this.listImages.reduce((imgs: string, image: any) => {
                const fileName = image.fileName ? image.fileName : (image.src ? image.src.replace(/^.*[\\\/]/, '') : '');
                return imgs + (imgs === '' ? fileName : (';' + fileName))
            }, ''),
        };

        const result = await payserviceService.addDetail(dataRequest);
        this.isLoading = false;
        if (result && result.status === 200 && result.data.status === 200) {
            Vue.notify({
                group: 'foo',
                type: 'success',
                title: 'Thông báo!',
                text: 'Tạo mới yêu cầu thanh toán hộ thành công!',
            });
            this.$router.push({ name: 'payservice-detail', params: { id: result.data.data.ID.toString() } }).catch(() => {
                return false;
            });
        } else {
            Vue.notify({
                group: 'foo',
                type: 'error',
                title: 'Thông báo!',
                text: 'Có lỗi trong quá trình xử lý dữ liệu!',
            });
        }
    }
}
